import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	snippetEditorModalTitleCreate: {
		id: 'snippets.snippetEditorModal.titleCreate',
		defaultMessage: 'Create block template',
		description: 'Title for the create block template modal',
	},
	snippetEditorModalCreateDescription: {
		id: 'snippets.snippetEditorModal.createDescription',
		defaultMessage: 'Save content and easily reuse it through / menu.',
		description: 'Description for the create template modal',
	},
	snippetEditorModalTitleEdit: {
		id: 'snippets.snippetEditorModal.titleEdit',
		defaultMessage: 'Edit block template',
		description: 'Title for the edit block template modal',
	},
	snippetEditorModalNameLabel: {
		id: 'snippets.snippetEditorModal.nameLabel',
		defaultMessage: 'Template Name',
		description: 'Label for the template name input',
	},
	snippetEditorModalNamePlaceholder: {
		id: 'snippets.snippetEditorModal.namePlaceholder',
		defaultMessage: 'Enter template name',
		description: 'Placeholder for the template name input',
	},
	snippetEditorModalNameError: {
		id: 'snippets.snippetEditorModal.nameError',
		defaultMessage: 'Name is required',
		description: 'Error message for the template name input',
	},
	snippetEditorModalDescriptionLabel: {
		id: 'snippets.snippetEditorModal.descriptionLabel',
		defaultMessage: 'Description',
		description: 'Description label for the modal',
	},
	snippetEditorModalDescriptionPlaceholder: {
		id: 'snippets.snippetEditorModal.descriptionPlaceholder',
		defaultMessage: 'Enter template description',
		description: 'Placeholder for the description input',
	},
	snippetEditorModalAccessLabel: {
		id: 'snippets.snippetEditorModal.accessLabel',
		defaultMessage: 'Access',
		description: 'Label for the Access field (Private/Shared)',
	},
	snippetEditorModalAccessPrivate: {
		id: 'snippets.snippetEditorModal.accessPrivate',
		defaultMessage: 'Private',
		description: 'Private access option for block templates',
	},
	snippetEditorModalAccessShared: {
		id: 'snippets.snippetEditorModal.accessShared',
		defaultMessage: 'Shared',
		description: 'Shared access option for block templates',
	},
	snippetEditorModalAccessPrivateTooltip: {
		id: 'snippets.snippetEditorModal.accessPrivateTooltip',
		defaultMessage: 'Save to this space to keep this template private',
		description: 'Tooltip for the Private access button',
	},
	snippetEditorModalAccessSharedTooltip: {
		id: 'snippets.snippetEditorModal.accessSharedTooltip',
		defaultMessage: "'Shared' lets your company access this template sitewide but not edit it.",
		description: 'Tooltip for the Shared access button',
	},
	snippetEditorModalAdfError: {
		id: 'snippets.snippetEditorModal.adfError',
		defaultMessage: 'Something went wrong, please make a new content selection',
		description: 'Error message for when the selected ADF is invalid',
	},
	snippetEditorModalCancelButton: {
		id: 'snippets.snippetEditorModal.cancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
	},
	snippetEditorModalCreateButton: {
		id: 'snippets.snippetEditorModal.createButton',
		defaultMessage: 'Create',
		description: 'Create button text for create mode',
	},
	snippetEditorModalSaveButton: {
		id: 'snippets.snippetEditorModal.saveButton',
		defaultMessage: 'Save',
		description: 'Save button text for edit mode',
	},
	snippetEditorModalEditSuccessFlagTitle: {
		id: 'snippets.snippetEditorModal.editSuccessFlagTitle',
		defaultMessage: 'Template "{snippetName}" updated',
		description: 'Success flag title shown when a block template has been updated',
	},
	snippetEditorModalEditErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.editErrorFlagTitle',
		defaultMessage: 'Could not update the template',
		description: 'Error flag title shown when a block template update fails',
	},
	snippetEditorModalEditErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.editErrorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Error flag description shown when a block template update fails',
	},
	snippetEditorModalSuccessFlagTitle: {
		id: 'snippets.snippetEditorModal.successFlagTitle',
		defaultMessage: 'Template "{snippetName}" created',
		description: 'Title for the success flag shown when template creation succeeds',
	},
	snippetEditorModalSuccessFlagDescription: {
		id: 'snippets.snippetEditorModal.successFlagDescription',
		defaultMessage: 'You can now use it from the / menu',
		description: 'Description for the success flag shown when template creation succeeds',
	},
	snippetEditorModalErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.errorFlagTitle',
		defaultMessage: 'Could not create template',
		description: 'Title for the error flag shown when template creation fails',
	},
	snippetEditorModalErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.errorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Description for the error flag shown when template creation fails',
	},
	snippetEditorModalTitleDuplicate: {
		id: 'snippets.snippetEditorModal.titleDuplicate',
		defaultMessage: 'Create duplicate of {snippetName}',
		description: 'Title for the duplicate block template modal',
	},
	snippetEditorModalDuplicateButton: {
		id: 'snippets.snippetEditorModal.duplicateButton',
		defaultMessage: 'Duplicate',
		description: 'Duplicate button text for duplicate mode',
	},
	snippetEditorModalDuplicateSuccessFlagTitle: {
		id: 'snippets.snippetEditorModal.duplicateSuccessFlagTitle',
		defaultMessage: 'Template "{snippetName}" duplicated',
		description: 'Success flag title shown when a block template has been duplicated',
	},
	snippetEditorModalDuplicateSuccessFlagDescription: {
		id: 'snippets.snippetEditorModal.duplicateSuccessFlagDescription',
		defaultMessage: 'You can now use it from the / menu',
		description: 'Description for the success flag shown when template duplication succeeds',
	},
	snippetEditorModalDuplicateErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.duplicateErrorFlagTitle',
		defaultMessage: 'Could not duplicate the template',
		description: 'Error flag title shown when a block template duplication fails',
	},
	snippetEditorModalDuplicateErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.duplicateErrorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Error flag description shown when a block template duplication fails',
	},
	snippetEditorModalShareErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.shareErrorFlagTitle',
		defaultMessage: 'Could not set template to shared',
		description: 'Error flag title when share API fails after create/edit/duplicate',
	},
	snippetEditorModalShareErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.shareErrorFlagDescription',
		defaultMessage: 'The template was saved but access update failed. Please try again.',
		description: 'Error flag description when setting access level to shared API fails',
	},
	snippetEditorModalUnshareErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.unshareErrorFlagTitle',
		defaultMessage: 'Could not set template to private',
		description: 'Error flag title when unshare API fails after edit',
	},
	snippetEditorModalUnshareErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.unshareErrorFlagDescription',
		defaultMessage: 'The template was saved but access update failed. Please try again.',
		description: 'Error flag description when setting access level to private API fails',
	},
});
